import styled, { DefaultTheme } from 'styled-components'

import { TypeStyle, fromMd, untilMd, zIndexModal } from '@syconium/little-miss-figgy'

import { NextModalStyles } from '../../modals/NextModal'

export function deriveModalStyles(theme: DefaultTheme): NextModalStyles {
  return {
    content: {
      backgroundColor: theme.color.deprecated.stoneLighter,
      borderRadius: 0,
      borderTop: '1px solid',
      borderColor: theme.color.deprecated.stoneLight,
      bottom: 'initial',
      boxSizing: 'border-box',
      left: 0,
      overflow: 'initial',
      padding: 'initial',
      position: 'absolute',
      right: 'initial',
      height: '100%',
      width: '100%',
      maxWidth: '100%',
      top: 0,
    },
    overlay: {
      backgroundColor: undefined,
      zIndex: zIndexModal + 1,
    },
  }
}

export const Body = styled.div`
  overflow: auto;
  ${fromMd} {
    padding: 0 ${o => o.theme.spacing(10)} ${o => o.theme.spacing(10)} ${o => o.theme.spacing(10)};
  }
`
export const Title = styled.h1`
  ${TypeStyle.css.headlineSmall}
  text-transform: uppercase;
`

export const Subtitle = styled.h2`
  ${TypeStyle.css.bodyNano}
  padding: ${o => o.theme.spacing(2)} 0;
`

export const ImageHeader = styled.div`
  text-align: center;
  padding-bottom: ${o => o.theme.spacing(5)};

  ${untilMd} {
    display: none;
  }
`

export const Section = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  position: relative;
`

export const ImagePreviewWrap = styled.div`
  width: 100%;
  ${fromMd} {
    position: relative;
  }
`

export const Container = styled.div`
  display: flex;
  position: relative;

  ${untilMd} {
    flex-direction: column;
  }

  ${fromMd} {
    width: 100%;
    height: calc(100% - ${o => o.theme.spacing(16)});
  }
`
